<template>
	<div class="wrap">
		<qr-code-url v-if="qrcodeUrl" :qrcodeUrl="qrcodeUrl" tips="充值" :chargeMoney="chargeMoney" @deletePay="deletePay"></qr-code-url>
        
		<common-modal :showClose="false" v-if="isShowModal">
			<div class="modal">
				<div class="body">
					<div v-if="isRechargeSucc">
						<img src="@/assets/images/my-wallet/pic_recharge_right.png" class="recharge-succ-icon">
						<div class="tip-text">充值成功</div>
					</div>
				  
					<div v-else>
						<img src="@/assets/images/my-wallet/pic_recharge_mistake.png" class="recharge-fail-icon">
						<div class="tip-text">充值失败</div>
					</div>
				</div>
			
				<div class="footer" @click="onOkclick">好的</div>
			</div>
		</common-modal>
		
		<div class="content">
			<div class="title-wrap">
				<img src="@/assets/images/personal/ic_mine_money.png" class="recharge-icon">
				<span>充值金额</span>
			</div>
			
			<div class="list">
				<div v-for="(item,index) of list" :key="item.uuid" :class="{item: true, selected: selectFlag == index}" @click="onItemClick(index,item)">
					<div>
						<span class="rmb">¥</span>
						<span class="amount">{{item.recharge_money}}</span>
					</div>
					<div class="send" v-if="item.recharge_amount">送{{item.recharge_amount}}</div>
				</div>
			</div>
            <div class="tip">
            	<span>点击立即充值，即表示已经同意<span @click="navigateTo('./protocol')" class="link">《充值协议》</span></span>
            </div>
			<div class="recharge-btn" @click="onRechargeClick">充值</div>
		</div>
	</div>
</template>

<script>
import CommonModal from './CommonModal'
import QrCodeUrl from './QrCodeUrl'
import { getRechargeClassList,postRecharge,getChargeStatus} from '@/api/wallet'
import wx from 'weixin-js-sdk'
import utils from '@/assets/jslibs/utils'

export default {
	name: 'recharge',
	components: {
		CommonModal,
		QrCodeUrl
	},
	
	data() {
		return {
			list: [],
            chargeMoney:"",
			timer:null,
			selectFlag:0,
			order_tag:"",    //支付方式
			order_uuid:"",   //充值的订单uuid
			uuid:"",           //所选充值档次的id
			selectedType: {},
			isShowModal: false,
			isRechargeSucc: true,
			qrcodeUrl : '',
			url:this.$route.query.url,
			isMobile : utils.isMobile(),
            payflag:false,
		}
	},
	
	beforeCreate(){
		sessionStorage.setItem("roleType","customer")
	},
	
	created() {
		clearTimeout(this.timer);
		this.getRechargeClassInfo();
	},
    
    mounted(){
        document.title = '充值中心';
        let self = this
        window.addEventListener('pageshow',()=>{
            if(sessionStorage.getItem("havePay") && sessionStorage.getItem("payId")) {
                self.order_uuid = sessionStorage.getItem("payId");      //取成功支付之后的订单号
                self.getChargeStatus();
                sessionStorage.removeItem("havePay");
                sessionStorage.removeItem("payId");
            }
        })
    },
	
	methods: {
		async getRechargeClassInfo() {
			const { data, status } = await getRechargeClassList();
			if( status !== 200 ) return
			this.list = data.char;
			this.uuid = this.list[0].uuid;       //默认选第一个档次
            this.chargeMoney = this.list[0].recharge_money
			console.log(data, '充值等级')
            
		},
		
		onItemClick(index,item) {
			if(this.selectFlag==index){
				this.selectFlag = -1;
			}else{
				this.selectFlag = index;
				this.uuid = item.uuid;
                this.chargeMoney = item.recharge_money
			}
		},
		
		// 充值
		async onRechargeClick() {
			if(this.selectFlag==-1){
				window.toast("请选择充值金额","txt")
				return
			}
            
            this.payflag = true
			let obj={type:"1",uuid:this.uuid , order_tag : 1};
      let web_obj = {type:"1",uuid:this.uuid , order_tag : 1};
			if(this.isMobile==1){
				obj.order_tag = 1
        web_obj.order_tag = 1;
			}else if(this.isMobile==2){
				obj.order_tag = 2
        web_obj.order_tag = 2;
			}else if(this.isMobile==3){
				obj.order_tag = 3
        web_obj.order_tag = 3;
			}

      //判断一下是不是在小程序中
      wx.miniProgram.getEnv(function (res) {
        if (res.miniprogram) {
          // 小程序环境下逻辑
          console.log("小程序环境,需要调用小程序支付");
          //obj.order_tag = 3;
          web_obj.order_tag = 4;
          obj.wx_type   = 'minApp' //小程序
        }
      });
			
			const { data, status } = await postRecharge(obj); 
			if( status == 200 ){
				if(web_obj.order_tag == 2){//扫码支付
					this.order_tag = "2"
					this.qrcodeUrl = data.code_url;
				} else if(web_obj.order_tag==1){
					this.order_tag = "1";
					sessionStorage.setItem("havePay","havePay");
					sessionStorage.setItem("payId",data.order_uuid);
                    var UserAgent = navigator.userAgent.toLowerCase();
                    if(/safari/.test(UserAgent) && !/chrome/.test(UserAgent)){
						var backUrl = "https://server-order.yongxintao.com/#/wallet";
						sessionStorage.setItem("backUrl",backUrl);
						sessionStorage.setItem("chargeUrl",this.url);				//充值成功的回调
                        location.href = data.mweb_url;
                    }else{
                        location.href = data.mweb_url;
                    }
				}else if(web_obj.order_tag==3){
                    let timeStamp = String(data.timeStamp);
					this.pay("wxf3c9d00e530fedd8",timeStamp,data.nonceStr,data.package,data.signType,data.paySign);
				}else if (web_obj.order_tag == 4){
          //小程序支付
          //this.AWechatJsPay();
          data.timeStamp = String(data.timeStamp);

          const payParamsStr = encodeURIComponent(JSON.stringify(data));
          const url=`../wxpay/wxpay?payParamsStr=${payParamsStr}`;
          wx.miniProgram.navigateTo({url:url});
          console.log('跳到小程序支付页面中去')
        }
                this.order_uuid = data.order_uuid;
				this.getChargeStatus()
			}
		},
        
        // 调微信支付
        pay(appId,timeStamp,nonceStr,packages,signType,paySign){  
        	let self = this;
            if (typeof WeixinJSBridge == "undefined"){  
               if( document.addEventListener ){  
                   document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);  
               }else if (document.attachEvent){  
                   document.attachEvent('WeixinJSBridgeReady', onBridgeReady);   
                   document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);  
               }  
            }else{  
               self.onBridgeReady(appId,timeStamp,nonceStr,packages,signType,paySign);  
            }   
        },  
        
        //唤醒微信支付
        onBridgeReady(appId,timeStamp,nonceStr,packages,signType,paySign){
            let self = this;
        	WeixinJSBridge.invoke(
        		'getBrandWCPayRequest',
        		{
        			"appId":"wxf3c9d00e530fedd8",     //公众号名称，由商户传入
        			"timeStamp":timeStamp,         //时间戳，自1970年以来的秒数     
        			"nonceStr":nonceStr, //随机串     
        			"package":packages,     
        			"signType":signType,         //微信签名方式：     
        			"paySign":paySign //微信签名 
        		},
        		
        		function(res){
        			if(res.err_msg == "get_brand_wcpay_request:ok"){// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        				if(this.url){
        					location.href = this.url
        				}else{
							this.$router.push("./wallet"); 
						}
        			}else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
                        window.toast("支付失败","txt");
        			}else if (res.err_msg === 'get_brand_wcpay_request:fail') {
                        window.toast("支付失败","txt");
        			}
        		}
        	)
        },
        
		// 轮询支付订单状态
		async getChargeStatus(){
			clearTimeout(this.timer);
			const { data, status } = await getChargeStatus(this.order_uuid);
			if( status == 200 && data.is_pay == 2){
				clearTimeout(this.timer);
				this.qrcodeUrl = false;
				// this.isShowModal = true;
				if(this.url){
					location.href = this.url
				}else{
					this.$router.push("./wallet"); 
				}
			}else{
				clearTimeout(this.timer);
				this.timer = setTimeout(()=>{
					this.getChargeStatus()
				},2000)
			}
		},
        
		// 成功结果弹框
		onOkclick () {
			this.isShowModal = false;
			this.selectFlag = -1;
			if(this.isRechargeSucc){//充值成功
				if(this.$route.query && this.$route.query.url){//余额不足的时候，充值回调
					location.href = this.$route.query.url
				}
				else{
					this.$router.push("./wallet");  
				}
			}else{
                this.isShowModal = false;
            }
		},
		
		// 关闭二维码
		deletePay(){
			this.qrcodeUrl = false;
			clearTimeout(this.timer);
		},
        
        navigateTo(path) {
        	this.$router.push(path)
        },
	}
}
</script>


<style lang="less" scoped>
@import '~@/assets/styles/variable.less';
@import '~@/assets/styles/handleMethods.less';

.wrap {
	.modal {
	.w(280);
    .h(145.5);
	.f-s(18);
    background:rgba(255,255,255,1);
    border-radius:4px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(0,0,0,1);
    position: relative;
    .body {
    	.recharge-succ-icon, .recharge-fail-icon {
    		.w(80);
    		.h(80);
    		position: absolute;
    		top: -1.07rem;
    		left: 2.67rem;
    	}
    	.tip-text {
    		.p-t(58);
    		.p-l(108);
    		.p-b(18.5);
		}
    }
    .footer {
    	.h(50);
    	.l-h(40);
    	text-align: center;
    	border-top: 1px solid rgba(229,229,229,1);
    }
	}
	.content {
    .m-l(15);
    .m-r(15);
    .f-s(16);
    	color:rgba(40,40,40,1);
		.title-wrap {
			display: flex;
			align-items: center;
			.m-t(21.5);
			.f-s(15);
			.l-h(21);
			font-family:PingFangSC-Regular;
			font-weight:400;
			color:rgba(40,40,40,1);
			.recharge-icon {
				.w(20);
				.h(20);
				.m-r(12.5);
			}
		}
		.list {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			.item {
				.w(167);
			  .h(71);
			  .m-t(10);
			  .m-b(10);
			  display: flex;
			  flex-direction: column;
			  align-items: center;
			  justify-content: center;
				background:rgba(255,255,255,1);
				border-radius:6px;
				border:1px solid rgba(207,207,207,1);
				.rmb {
					font-family:PingFangSC-Semibold;
					font-weight:600;
					font-size:16px;
					color:rgba(51,51,51,1);
					.l-h(22.5);
					letter-spacing:1px;
					
				}
				.amount {
					.f-s(24);
					.l-h(33.5);
					font-family:PingFangSC-Semibold;
					font-weight:600;
					color:rgba(51,51,51,1);
					letter-spacing:2px;
				}
				.send {
					.f-s(12);
					.l-h(16.5);
					margin-top: 2px;
					font-family:PingFangSC-Regular;
					font-weight:400;
					color:rgba(51,51,51,1);
					letter-spacing:1px;
				}
			}
			.selected {
				background: rgba(74,144,226,1);
				.rmb, .amount, .send {
          color:rgba(255,255,255,1)
				}
			}
		}
		/deep/.border-top-1px::before, /deep/.border-bottom-1px::after  {
			border: 0;
		}
		/deep/.cube-radio-group {
			.m-t(18);
			.weixin-icon, .alipay-icon {
				.m-r(13.5);
			}
			.weixin-icon {
				.w(18);
				.h(15);
			}
			.alipay-icon {
				.w(18);
				.h(16.5);
			}
			.border-bottom-1px::after, {
				border: 0;
			}
		}
		.tip {
			.f-s(12);
			.l-h(16.5);
			.m-t(16);
			font-family:PingFangSC-Regular;
			font-weight:400;
			color:rgba(193,193,193,1);
			text-align: center;
      .link {
      	color: rgba(0,0, 0, 1);
      }
		}
		.recharge-btn {
			.w(337.5);
			.h(46);
			.l-h(46);
			.f-s(16);
			.m-t(15);
			text-align: center;
			font-family:PingFangSC-Regular;
			font-weight:400;
			color:rgba(255,255,255,1);
			background:rgba(65,132,244,1);
			border-radius:5px;
		}
	}
}
</style>